import Modal from "../../molecules/Modal"
import style from "./index.module.scss"
import mock_img from "../../../assets/img/mock_img.png"
import { fnCreateBoardFromModel } from "../../../services/boards"
import { useParams } from "react-router-dom"
import { useContext } from "react"

export default function ModalShowDetail(props) {
  const { isOpen, onClose, data, fetchBoards, completeClose } = props

  const { panelId } = useParams()

  const handleCreateBoard = async () => {
    await fnCreateBoardFromModel(panelId, data?.opmd_nid)
    await fetchBoards(1)
    completeClose()
  }

  return (
    <Modal isOpen={isOpen} size={"lg"} onClose={onClose}>
      <Modal.Header onClose={onClose}>Detalhes do Modelo</Modal.Header>
      <Modal.Content size={"lg"}>
        <div className={style.content}>
          <div className={style.detailHeader}>
            <h3>{data?.opmd_cname}</h3>
            <button onClick={handleCreateBoard}>Usar Modelo</button>
          </div>
          <img src={data?.opmd_cimage} alt="" className={style.imgBg} />
          <p>{data?.opmd_cdescription}</p>
          {/* <h3>{data?.opmd_cname}</h3>
          <img src={data?.opmd_cimage} alt={data?.opmd_cname} />
           */}
        </div>
      </Modal.Content>
      {/* <Modal.Footer size={"2xl"}>
        <button>Selecionar</button>
      </Modal.Footer> */}
    </Modal>
  )
}
